<template>
  <div class="container">
    <div>
      <span>自动登录中,请稍后</span> <span v-for="i in points" :key="i">.</span>
    </div>
  </div>
</template>

<script>
import { decrypt } from "@/utils/crypto";
import { getCookie, setCookie, delCookie } from "@/utils/cookie";
import { login, getUserPermissionList } from "@/api/index";
export default {
  data() {
    return {
      router: null,
      points: 1,
      timer: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.points = (this.points % 3) + 1;
      }, 500);
      this.autoLogin();
    });
  },
  methods: {
    async autoLogin() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const account = urlParams.get("username");
      const password = urlParams.get("pwd");
      let param = {
        username: account,
        password: decrypt(password),
      };
      login(param).then(async (res) => {
        if (res.code == 200) {
          localStorage.setItem("token", res.data.token);
          let menu = res.data.permission;
          let m = [];
          menu.forEach((f, index) => {
            if (f.class.length == 1) {
              m.push({
                id: index,
                route: f.permission,
                pid: f.pid == 0 ? "" : f.pid,
              });
            }
          });
          const route = await this.$router.selfAddRoutes(m);
          this.$store.commit("SET_LOGIN_STATUS", true);
          setCookie("open_token", res.data.token); // 刷新后vuex登陆状态会重置 存一份cookie用于判断
          localStorage.setItem(
            "permission",
            JSON.stringify(res.data.permission)
          );
          localStorage.setItem("username", account);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
          this.$router.push("/login");
        }
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}
</style>